import React from 'react'
import BodySection from '../../../components/AdminDashboard/ClubSubscription/EditPackage/BodySection'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const EditPackage = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Body */}
            <BodySection />

        </div>
    )
}

export default EditPackage